'use client'

import { useState } from 'react'

export default function HeroCard({ label, value, detail, bf }: {
  label: string
  value: React.ReactNode
  detail: React.ReactNode
  bf: string
}) {
  const [open, setOpen] = useState(false)

  return (
    <div
      className="border border-zinc-800 px-3 py-3 sm:px-4 sm:py-5 cursor-pointer sm:cursor-default"
      onClick={() => setOpen(o => !o)}
    >
      <div className="flex items-center justify-between mb-1.5 sm:mb-3">
        <div className="text-zinc-400 text-[9px] sm:text-xs uppercase tracking-widest" style={{ fontFamily: bf }}>{label}</div>
        <svg
          className={`w-3 h-3 text-zinc-600 sm:hidden transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      <div className="text-zinc-100 text-xl sm:text-2xl lg:text-3xl font-bold tabular-nums leading-none" style={{ fontFamily: bf }}>{value}</div>
      <div className={`text-zinc-400 text-xs overflow-hidden transition-all duration-200 sm:mt-2 sm:max-h-20 sm:opacity-100 ${open ? 'mt-2 max-h-20 opacity-100' : 'max-h-0 opacity-0'}`} style={{ fontFamily: bf }}>
        {detail}
      </div>
    </div>
  )
}